import { render, staticRenderFns } from "./StockListWarehouses.vue?vue&type=template&id=68d27ec4"
import script from "./StockListWarehouses.vue?vue&type=script&lang=js"
export * from "./StockListWarehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports